import { MouseEvent } from 'react'

import RestrictionsSettingsModal from 'app/components/common/RestrictionsSettingsModal'


type Dish = {
  id: number | null
  title: string
}
type Props = {
  orgId: string
  dish: Dish
  writeAccess: boolean
  onClose: (e?: MouseEvent<HTMLElement>) => void
}

export const SettingsModal = ({ orgId, dish, writeAccess, onClose }: Props) => {
  if (!writeAccess || !dish.id) return null

  return (
    <RestrictionsSettingsModal
      header="Настройки"
      headPhrase={`Для кого используется продукция «${dish.title}»`}
      orgId={parseInt(orgId, 10)}
      dishId={dish.id}
      onClose={onClose}
    />
  )
}

